/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Tag } from "primereact/tag";
import {
  Boton,
  Titulo,
  Formulario,
  accessAPI,
  Sidebar,
  tituloBase,
  TablaFiltrable
} from "../../../shared";

const SEARCH_FIELDS = ["nombre"];

export default function AuditorTipos() {
  const [loader, setLoader] = useState(true);
  const [auditorTipos, setAuditorTipos] = useState([]);
  const [sideBar, setSideBar] = useState(false);
  const [formLoader, setFormLoader] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();

  function crearTipoAuditor(camposFormulario) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/auditor/tipoAuditor",
      camposFormulario,
      (respuesta) => {
        navigate(`/proveedores/auditortipos/${respuesta.id}`);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear tipo de colaborador",
          sticky: true
        });
      }
    );
  }

  const crearFormConfig = {
    secciones: [
      {
        nombre: "Datos del tipo de colaborador",
        campos: [
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre",
            requerido: true
          },
          {
            nombre: "esRevisorSolicitud",
            tipoitemformularioid: 6,
            etiqueta: "Revisor de solicitudes"
          }
        ]
      }
    ],
    botones: [
      { etiqueta: "Crear", callback: crearTipoAuditor, validar: true }
    ]
  };

  useEffect(() => {
    document.title = "Tipos de colaborador";
    accessAPI(
      "GET",
      "admin/auditor/auditortipo",
      null,
      (respuesta) => {
        setAuditorTipos(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg || "Error al cargar tipos de colaborador",
          sticky: true
        });
        setLoader(false);
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Sidebar
        visible={sideBar}
        onHide={() => setSideBar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nuevo tipo de colaborador</Titulo>
        <Formulario config={crearFormConfig} loader={formLoader} />
      </Sidebar>

      {loader && (
        <div
          css={{
            marginTop: "2em",
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem"
          }}
        >
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0.5rem"
            }}
          >
            <Skeleton width="15rem" height="2.5rem" />
            <Skeleton width="16rem" height="2.5rem" />
          </div>
          <Card>
            <div
              css={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem"
              }}
            >
              <Skeleton width="100%" height="3rem" />
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            urlVolver="/config"
            botones={
              <Boton callback={() => setSideBar(true)}>
                Nuevo tipo de colaborador
              </Boton>
            }
          >
            Tipos de colaborador
          </Titulo>

          <Card>
            <TablaFiltrable
              value={auditorTipos}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="tipos_colaborador"
              emptyMessage="No hay tipos de colaborador registrados"
              onRowClick={(e) => {
                if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
                  window.open(
                    `/proveedores/auditortipos/${e.data.id}`,
                    "_blank"
                  );
                } else {
                  navigate(`/proveedores/auditortipos/${e.data.id}`);
                }
              }}
              css={{
                "& .p-datatable-tbody > tr": { cursor: "pointer" }
              }}
            >
              <Column header="Nombre" field="nombre" />
              <Column
                header="Revisor de solicitudes"
                body={(rowData) => (
                  <Tag
                    severity={rowData.esRevisorSolicitud ? "success" : "danger"}
                    css={{ fontSize: "0.75rem" }}
                  >
                    <i
                      className={
                        rowData.esRevisorSolicitud
                          ? "pi pi-check"
                          : "pi pi-times"
                      }
                    />
                  </Tag>
                )}
                style={{ width: "12rem", textAlign: "center" }}
              />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
